import { useEffect, useState } from "react";
import { StreamChat } from "stream-chat";
import { getStreamChatClient } from "@/components/pages/chats/StreamChatClientManager";
import { useUserChatToken } from "@/components/pages/chats/hooks/useUserChatToken";

export const useChatClient = (hotelId: string | null, enabled = true) => {
  const [client, setClient] = useState<StreamChat | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { userChatData: chatData, isLoading: isTokenLoading } =
    useUserChatToken(hotelId, enabled);

  useEffect(() => {
    let isMounted = true;

    const initClient = async () => {
      try {
        setIsLoading(true);

        if (!enabled) {
          setClient(null);
          setUserId(null);
          return;
        }

        if (!isMounted || !chatData?.token || !chatData?.chatUserId) {
          return;
        }

        const chatClient = await getStreamChatClient(
          chatData.chatUserId,
          chatData.token,
        );

        if (isMounted) {
          setClient(chatClient);
          setUserId(chatData.chatUserId);
        }
      } catch (error) {
        console.error("Failed to initialize chat client:", error);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initClient();

    return () => {
      isMounted = false;
    };
  }, [chatData, enabled]);

  const hasCurrentHotelSession =
    enabled && Boolean(chatData?.chatUserId) && userId === chatData?.chatUserId;

  return {
    client: hasCurrentHotelSession ? client : null,
    userId: hasCurrentHotelSession ? userId : null,
    isLoading: enabled && (isTokenLoading || isLoading),
  };
};
